module.exports = __webpack_public_path__ + "img/emoji-sad-off.3d162c1d.svg";